import { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import config from '../../config';
import { Button } from '../button/button.component';
import { getLanguageRootFromPath } from '../../utils/get-language-root';

import { BreadcrumbProps } from './breadcrumb.config';

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const { t } = useTranslation();
  const filteredItems = useMemo(() => items?.filter((_, index) => !index || index >= items.length - 2), [items]);

  return (
    <div className="snowflake-breadcrumb" data-testid="snowflake-breadcrumb">
      <Swiper className="snowflake-breadcrumb-swiper" slidesPerView="auto">
        {filteredItems.map((item, index) => (
          <SwiperSlide
            data-testid="snowflake-breadcrumb-swiper-slider"
            className="snowflake-breadcrumb-swiper-slider"
            key={item.link.url}
          >
            <div className={classNames('snowflake-button-link', { 'snowflake-button-blue': !item.active })}>
              <Button
                className={classNames('snowflake-breadcrumb-item', {
                  'snowflake-breadcrumb-item-active': item.active,
                  'snowflake-breadcrumb-item-hidden-current-page': !item.active && index === filteredItems.length - 1,
                })}
                isLink
                text={
                  config.SUPPORTED_LANGUAGES?.includes(getLanguageRootFromPath(item.link.url))
                    ? t('home_page')
                    : item.title
                }
                buttonLink={item.link}
                disableAnchor={item.active}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Breadcrumb;
